import { Mixpanel } from '@/utils/mixpanel';
import { useSelector } from 'react-redux';

import extensionScreenshot from '../../../images/screenshots/extension-screenshot.webp';
import { setStorage } from '../../../utils/auth-utils';
import { TransparentButton } from '../../styledComponents/index';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import ModalComponent from './ModalComponent';

export default function InstallExtensionModal({ show, handleClose }) {
  const { userDetails } = useSelector((state) => state.user);
  return (
    <ModalComponent show={show} onClose={handleClose} width={450} outsideClickClose={false}>
      <div className="warning-modal modal-main-content">
        <IconContainer icon="🎉" />
        <h2>Welcome to SARAL!</h2>
        <p className="enter-list-name" style={{ fontSize: 13 }}>
          Before you explore the tool, we wanted to show you our{' '}
          <a
            href="https://chrome.google.com/webstore/detail/saral/fiienncdapmaacfjbfaomcfogknalfep"
            target="_blank"
            rel="noopener noreferrer">
            Chrome Extension
          </a>
          . Install it on chrome so you're able to find info on the fly for Instagram, Youtube, and Tiktok creators!
        </p>
        <img
          src={extensionScreenshot}
          alt="extension screenshot"
          style={{ marginTop: 14, width: '100%', border: '1px solid blue', borderRadius: '5px' }}
        />
        <div className="extension-modal-footer-button-container">
          <ButtonComponent onClick={() => setStorage('isExtensionModalShown', true)} variant="primary">
            <a
              href="https://chrome.google.com/webstore/detail/saral/fiienncdapmaacfjbfaomcfogknalfep"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#fff' }}
              onClick={() => {
                Mixpanel.identify(userDetails?._id);
                Mixpanel.track('chrome_ext_install', {
                  userId: userDetails?._id,
                });
              }}>
              Click here to install
            </a>
          </ButtonComponent>
          <TransparentButton
            className="btn2"
            onClick={() => {
              setStorage('isExtensionModalShown', true);
              handleClose();
            }}
            style={{ marginTop: 2 }}>
            I installed it, let me in!
          </TransparentButton>
        </div>
      </div>
    </ModalComponent>
  );
}
